<div class="playersCount">
  <ion-icon src="assets/global/img/Users.svg" class="playersCount--icon"></ion-icon>
  <div class="playersCount--text">
    <span class="playersCount--bold">{{ playersCount }} {{ 'CasPlayers' | translate }}</span>
    <!-- últimas 24h -->
    <span> {{ 'CasWeek' | translate }} </span>
  </div>
</div>
